import React, { createContext, useContext, useEffect } from 'react';
import signalRService from './SignalRService';

// Create the context
const SignalRContext = createContext(null);

// Create a provider component
export const SignalRProvider = ({ children,...props }) => {
    useEffect(() => {
        signalRService.startConnection();

        return () => {
            signalRService.stopConnection();
        };
    }, []);

    return (
        <SignalRContext.Provider value={signalRService}>
            {children}
        </SignalRContext.Provider>
    );
};

// Create a custom hook to use the SignalR context
export const useSignalR = () => {
    return useContext(SignalRContext);
};
